import { useEffect } from 'react';
import Logo from './assets/images/iec-logo.png';
import './styles/header.css'

const Header = () => {
    useEffect(() => {
        const dropdowns = document.querySelectorAll('.dropdown');
      
        dropdowns.forEach(drop => {
          const menu = drop.querySelector('.dropdown-menu');
      
          const showMenu = () => {
            if (menu) menu.classList.add('show');
          };
      
          const hideMenu = () => {
            if (menu) menu.classList.remove('show');
          };
      
          drop.addEventListener('mouseenter', showMenu);
          drop.addEventListener('mouseleave', hideMenu);
      
          // Cleanup
          return () => {
            drop.removeEventListener('mouseenter', showMenu);
            drop.removeEventListener('mouseleave', hideMenu);
          };
        });
      }, []);
      
    return (
        <header className='section-header'>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-12'>
                        <div className='header-wrapper'>
                            {/* <div className='header-navbar-wrapper'>
                                <ul className="nav navbar-nav">
                                    <li className="dropdown">
                                        <a href="/test/india-embroidery" className="dropdown-toggle" data-toggle="dropdown">Our Story <span className="lnr lnr-chevron-down"></span></a>
                                        <ul className="dropdown-menu">
                                            <li><a href="/test/india-embroidery/about-us">About Us</a></li>
                                            <li><a href="/test/india-embroidery/our-process">Our Process</a></li>
                                        </ul>
                                    </li>
                                    <li><a href='/test/india-embroidery/our-work'>Our Work</a></li>
                                    <li><a href="/test/india-embroidery" className="dropdown-toggle" data-toggle="dropdown">Facilities <span className="lnr lnr-chevron-down"></span></a>
                                        <ul className="dropdown-menu">
                                            <li><a href="/test/india-embroidery/about-us">About Us</a></li>
                                            <li><a href="/test/india-embroidery/our-process">Our Process</a></li>
                                        </ul>
                                    </li>
                                    <li><a href='/test/india-embroidery'>News & Blogs</a></li>
                                </ul>
                            </div> */}
                            <div className='header-logo-wrapper'>
                                <a className='header-logo' href='/'>
                                    <img src={Logo} alt='India Embroidery' className='w-100' />
                                </a>
                            </div>
                            {/* <div className='theme-btn-wrapper'>
                                <a className='theme-btn' href='/test/india-embroidery/contact-us'>
                                    <span data-text="Contact Us">
                                        Contact Us
                                    </span>
                                    <svg aria-hidden="true" className="e-font-icon-svg e-fas-caret-right" viewBox="0 0 192 512" xmlns="http://www.w3.org/2000/svg"><path d="M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"></path></svg>
                                </a>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header